import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';
import { getInteractiveStyle } from '@/src/materialui/button/interactive';

export const flowMenuItem: Components<Theme>['MuiMenuItem'] = {
  defaultProps: {
    tabIndex: 0,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      cursor: 'pointer',
      // proportions
      padding: '12px',
      maxWidth: '100%',
      // space between children (e.g. icon and text)
      gap: '10px',
      // custom font according to Figma
      color: theme.palette.text.primary,
      [theme.breakpoints.up('xs')]: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
      },
      // 1 line ellipsis
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      // overwrite style for ListItemText
      '& .MuiListItemText-root .MuiListItemText-primary': {
        fontSize: 'inherit',
        lineHeight: 'inherit',
        fontWeight: 'inherit',
        color: 'inherit',
        // also support just 1 line ellipsis
        display: 'block',
      },
      // focus
      position: 'relative',
      ...getFocusRingStyle(theme, false, '2px'),
      '&&:before': {
        borderRadius: '4px',
      },
      ...getInteractiveStyle(
        {
          // with checkbox inside also apply default styling once selected
          '&, &.Mui-selected:has(.PrivateSwitchBase-input), &[aria-selected="true"]:has(.PrivateSwitchBase-input)': {
            backgroundColor:
              theme.palette.mode === 'dark' ? theme.palette.onSurface.os800 : theme.palette.background.primary,
          },
        },
        { backgroundColor: theme.palette.surface.primary },
        { backgroundColor: theme.palette.surface.secondary },
        {
          // with checkbox correctly remove hover effect
          '&.Mui-selected:has(.PrivateSwitchBase-input):hover:not(:active):not(.Mui-focusVisible), &[aria-selected="true"]:has(.PrivateSwitchBase-input):hover:not(:active):not(.Mui-focusVisible)':
            {
              backgroundColor:
                theme.palette.mode === 'dark' ? theme.palette.onSurface.os800 : theme.palette.background.primary,
            },
        },
      ),
      // disabled state
      '&.Mui-disabled': {
        '&, & .MuiListItemText-primary': {
          // remove default @mui styling
          opacity: '1',
          color: theme.palette.disabled.primary,
        },
      },
      // divider inside
      '& + .MuiDivider-root': {
        // no extra margin
        margin: '0',
      },
      // ListItemIcon wrapper inside
      '& .MuiListItemIcon-root': {
        // keep color from parent
        color: 'currentColor',
        // no longer need to match width with IconButton
        minWidth: '0',
      },
      // Checkbox/Radio at the end
      '& .PrivateSwitchBase-root:last-child': {
        // extra space between text and switch
        marginLeft: '25px',
      },
    }),
  },
};
